export class DebugConsole {
  private text = '';
  /** @constructor */
  public constructor() {}
  public getText(): string {
    return this.text;
  }
  public resetText(): void {
    this.text = '';
  }
  print(text: string): void {
    this.text += text;
  }
}
